import styled from "styled-components";

export default styled.div`
  // display: flex;
  justify-content: center;
  align-items: center;
  height: 105vmin;
  width: 100%;
  border-radius:1vmin;
  color: #fff;
  margin: 0 3vmin;
  font-size: 4em;
`;